// System
import { Select } from '@mui/material';
import { useMemo } from 'react';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useLocation } from 'react-router';
import { ProvidersTableGames, ProvidersTableGamesKeys } from '@Modal/reducers/providers/types';

const GamesDropdown = () => {
  const { handleGameChange, game } = useGeneral();
  const { currentUser, currentProvider } = useAuthorization();
  const location = useLocation();

  const allowedPaths = ['/providers', '/transactions', '/languages', '/rounds'];
  const isAllowedPage = allowedPaths.some((path) => location.pathname.endsWith(path));

  const isSuper = currentUser?.isSuper;
  const gamesForAdmin = [1, 2, 3];
  // @TODO update after
  const userGames = currentProvider?.games;
  const dropdownConfig = useMemo(() => {
    const options = isSuper ? gamesForAdmin : userGames;
    const shouldShowSelect = isSuper || (userGames && userGames.length > 1);
    const currentGame = game;

    return {
      options,
      shouldShowSelect,
      currentGame,
    };
  }, [game, isSuper, userGames, gamesForAdmin]);

  if (!isAllowedPage || !dropdownConfig.shouldShowSelect) return null;

  return (
    <Select
      sx={{ height: '32px' }}
      value={dropdownConfig.currentGame}
      onChange={(event) => handleGameChange(event.target.value as number)}
    >
      {dropdownConfig.options.map((game) => (
        <MenuItemEx key={game} name={'Game'} value={game}>
          {ProvidersTableGames[game as ProvidersTableGamesKeys]}
        </MenuItemEx>
      ))}
    </Select>
  );
};

export default GamesDropdown;
